var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _g, _g2, _g3, _g4, _g5, _g6, _rect2, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFeatureDiscoverySyncFrequency = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 191,
    viewBox: "0 0 335 191",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.325 131.891C229.604 133.182 227.021 138.502 225.33 140.654L240.089 148.956C241.195 148.218 244.547 142.806 246.084 140.193C243.778 136.964 233.17 130.507 231.325 131.891Z",
    fill: "url(#paint0_linear_461_8215)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.656 146.282C240.713 147.111 240.894 147.952 240.118 149.05C209.067 193.028 152.495 201.664 110.054 169.804L95.2392 189.081C93.8563 190.863 91.013 190.082 90.7301 187.847L87.4547 142.593C87.2774 141.206 87.9103 140.001 89.2996 139.825L132.902 131.912C135.138 131.63 136.599 134.193 135.217 135.974L121.585 155.046C153.799 178.963 202.298 178.107 225.82 139.825C226.642 138.582 228.337 138.445 229.51 139.364L239.656 146.282Z",
    fill: "#FBEAB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.656 146.282C240.713 147.111 240.894 147.952 240.118 149.05C209.067 193.028 152.495 201.664 110.054 169.804L95.2392 189.081C93.8563 190.863 91.013 190.082 90.7301 187.847L87.4547 142.593C87.2774 141.206 87.9103 140.001 89.2996 139.825L132.902 131.912C135.138 131.63 136.599 134.193 135.217 135.974L121.585 155.046C153.799 178.963 202.298 178.107 225.82 139.825C226.642 138.582 228.337 138.445 229.51 139.364L239.656 146.282Z",
    fill: "url(#paint1_linear_461_8215)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.656 146.282C240.713 147.111 240.894 147.952 240.118 149.05C209.067 193.028 152.495 201.664 110.054 169.804L95.2392 189.081C93.8563 190.863 91.013 190.082 90.7301 187.847L87.4547 142.593C87.2774 141.206 87.9103 140.001 89.2996 139.825L132.902 131.912C135.138 131.63 136.599 134.193 135.217 135.974L121.585 155.046C153.799 178.963 202.298 178.107 225.82 139.825C226.642 138.582 228.337 138.445 229.51 139.364L239.656 146.282Z",
    fill: "url(#paint2_linear_461_8215)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9186 58.4293C98.5973 57.0836 101.262 51.6559 102.63 49.4782L87.8868 41.0479C86.9644 41.9703 83.3534 47.944 81.9007 50.6056C84.3092 53.7581 95.1191 59.8717 96.9186 58.4293Z",
    fill: "url(#paint3_linear_461_8215)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3643 43.7806C87.3075 42.9516 87.1271 42.1112 87.9031 41.0132C118.953 -2.96492 175.526 -11.6007 217.966 20.259L232.782 0.982273C234.164 -0.799809 237.008 -0.0192375 237.291 2.21605L240.566 47.4703C240.743 48.8569 240.11 50.0624 238.721 50.2376L195.119 58.151C192.883 58.4328 191.422 55.8697 192.804 54.0893L206.436 35.0175C174.222 11.1002 125.723 11.956 102.201 50.2376C101.379 51.4811 99.6836 51.6176 98.5111 50.6988L88.3643 43.7806Z",
    fill: "#FBEAB5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3643 43.7806C87.3075 42.9516 87.1271 42.1112 87.9031 41.0132C118.953 -2.96492 175.526 -11.6007 217.966 20.259L232.782 0.982273C234.164 -0.799809 237.008 -0.0192375 237.291 2.21605L240.566 47.4703C240.743 48.8569 240.11 50.0624 238.721 50.2376L195.119 58.151C192.883 58.4328 191.422 55.8697 192.804 54.0893L206.436 35.0175C174.222 11.1002 125.723 11.956 102.201 50.2376C101.379 51.4811 99.6836 51.6176 98.5111 50.6988L88.3643 43.7806Z",
    fill: "url(#paint4_linear_461_8215)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3643 43.7806C87.3075 42.9516 87.1271 42.1112 87.9031 41.0132C118.953 -2.96492 175.526 -11.6007 217.966 20.259L232.782 0.982273C234.164 -0.799809 237.008 -0.0192375 237.291 2.21605L240.566 47.4703C240.743 48.8569 240.11 50.0624 238.721 50.2376L195.119 58.151C192.883 58.4328 191.422 55.8697 192.804 54.0893L206.436 35.0175C174.222 11.1002 125.723 11.956 102.201 50.2376C101.379 51.4811 99.6836 51.6176 98.5111 50.6988L88.3643 43.7806Z",
    fill: "url(#paint5_linear_461_8215)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 56.999,
    width: 121,
    height: 102,
    rx: 35,
    fill: "url(#paint6_radial_461_8215)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_461_8215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.977,
    y: 105.73,
    width: 25.2686,
    height: 25.2683,
    rx: 3.54036,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.05,
    height: 18.05,
    transform: "translate(268.458 109.472)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_8215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.239 122.421L272.787 123.364C272.9 123.562 273.064 123.718 273.256 123.831L275.21 120.458H271.301C271.301 120.678 271.358 120.898 271.472 121.096L272.239 122.421Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.506 116.49L275.551 113.118C275.359 113.231 275.196 113.387 275.082 113.585L271.472 119.821C271.36 120.015 271.301 120.235 271.301 120.458H275.21L277.506 116.49Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.756 123.831C281.948 123.718 282.111 123.562 282.225 123.364L282.452 122.974L283.54 121.096C283.653 120.898 283.71 120.678 283.71 120.458H279.801L280.633 122.088L281.756 123.831Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.506 116.491L279.46 113.118C279.268 113.004 279.048 112.948 278.821 112.948H276.191C275.963 112.948 275.743 113.012 275.551 113.118L277.506 116.491Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.801 120.458H275.21L273.256 123.831C273.448 123.945 273.668 124.001 273.895 124.001H281.116C281.344 124.001 281.564 123.938 281.756 123.831L279.801 120.458Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.735 116.703L279.929 113.585C279.816 113.387 279.652 113.231 279.46 113.118L277.506 116.49L279.801 120.458H283.703C283.703 120.239 283.646 120.019 283.533 119.821L281.735 116.703Z",
    fill: "#FFBA00"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddd_461_8215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.488,
    y: 105.73,
    width: 25.2686,
    height: 25.2683,
    rx: 3.54036,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.0489,
    height: 18.0489,
    transform: "translate(236.111 109.382)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.661 117.953C242.827 117.304 243.413 116.851 244.086 116.851C244.762 116.851 245.345 117.303 245.512 117.953H242.661ZM246.03 118.348C246.125 118.23 246.161 118.077 246.131 117.916C246.007 117.331 245.687 116.862 245.208 116.56C244.878 116.352 244.494 116.242 244.096 116.242C243.657 116.242 243.239 116.373 242.887 116.622C242.337 117.012 242.009 117.648 242.009 118.324C242.009 118.494 242.03 118.662 242.072 118.825C242.283 119.648 242.994 120.271 243.84 120.375C243.922 120.385 244.004 120.389 244.084 120.389C244.254 120.389 244.419 120.368 244.588 120.324C244.809 120.271 245.019 120.182 245.213 120.06C245.396 119.942 245.565 119.782 245.742 119.56L245.754 119.548C245.813 119.474 245.84 119.38 245.829 119.289C245.819 119.207 245.78 119.137 245.719 119.091C245.661 119.046 245.592 119.022 245.525 119.022C245.459 119.022 245.363 119.045 245.276 119.158L245.269 119.168C245.24 119.206 245.211 119.245 245.176 119.284C245.059 119.416 244.924 119.524 244.776 119.606C244.563 119.718 244.334 119.776 244.094 119.778C243.342 119.77 242.881 119.271 242.7 118.808C242.672 118.724 242.652 118.648 242.639 118.577C242.639 118.57 242.638 118.563 242.638 118.555L245.552 118.555C245.755 118.55 245.924 118.477 246.03 118.348Z",
    fill: "#53B3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.277 117.761C249.984 117.761 249.746 117.997 249.746 118.288C249.746 118.579 249.984 118.815 250.277 118.815C250.569 118.815 250.807 118.579 250.807 118.288C250.807 117.997 250.569 117.761 250.277 117.761Z",
    fill: "#53B3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.344 116.572C248.344 116.407 248.208 116.272 248.041 116.272L247.956 116.271C247.698 116.271 247.453 116.35 247.247 116.5C247.208 116.378 247.092 116.293 246.962 116.293C246.795 116.293 246.663 116.424 246.662 116.591L246.663 120.05C246.664 120.215 246.798 120.349 246.963 120.349C247.128 120.349 247.263 120.215 247.263 120.05V117.923C247.263 117.234 247.323 116.945 247.922 116.872C247.972 116.866 248.026 116.865 248.039 116.865C248.216 116.859 248.344 116.736 248.344 116.572Z",
    fill: "#53B3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.434 118.31L241.99 116.756C242.047 116.701 242.078 116.626 242.078 116.546C242.078 116.381 241.942 116.246 241.776 116.246C241.695 116.246 241.619 116.278 241.561 116.336L240.006 117.882L238.444 116.333C238.387 116.277 238.312 116.246 238.232 116.246C238.066 116.246 237.931 116.381 237.931 116.546C237.931 116.626 237.963 116.702 238.022 116.76L239.578 118.309L238.024 119.859C237.964 119.916 237.931 119.993 237.931 120.075C237.931 120.24 238.066 120.374 238.232 120.374C238.311 120.374 238.386 120.344 238.444 120.288L240.004 118.736L241.558 120.281C241.617 120.342 241.695 120.375 241.776 120.375C241.942 120.375 242.078 120.24 242.078 120.075C242.078 119.996 242.047 119.921 241.99 119.863L240.434 118.31Z",
    fill: "#53B3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.277 119.738C249.473 119.738 248.82 119.088 248.82 118.289C248.82 117.488 249.473 116.837 250.277 116.837C251.08 116.837 251.733 117.488 251.733 118.289C251.733 119.088 251.08 119.738 250.277 119.738ZM250.277 116.219C249.131 116.219 248.199 117.148 248.199 118.288C248.199 119.429 249.131 120.357 250.277 120.357C251.423 120.357 252.355 119.429 252.355 118.288C252.355 117.148 251.423 116.219 250.277 116.219Z",
    fill: "#53B3E5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dddd_461_8215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 105.73,
    width: 25.2686,
    height: 25.2683,
    rx: 3.54036,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.0489,
    height: 18.0489,
    transform: "translate(203.623 109.294)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.503,
    y: 113.04,
    width: 10.2428,
    height: 10.6037,
    fill: "url(#pattern0)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dddd_461_8215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.732,
    y: 82.2651,
    width: 28.8784,
    height: 28.8781,
    rx: 3.54036,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.6587,
    height: 21.6587,
    transform: "translate(252.323 85.9253)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.348 94.7746C267.244 94.7746 268.881 96.3984 268.881 98.2877C268.881 100.322 267.311 101.905 265.238 101.905C263.356 101.905 261.715 100.589 261.715 98.4765V91.6108H262.805L262.806 95.806L262.935 95.6713C263.409 95.2042 264.086 94.7746 265.348 94.7746ZM265.238 100.92C266.784 100.92 267.767 99.828 267.767 98.388C267.767 97.0642 266.838 95.8005 265.263 95.8005C263.687 95.8005 262.71 96.9792 262.71 98.4145C262.71 99.8489 263.869 100.92 265.238 100.92ZM259.53 92.4397C260.343 93.2919 260.429 93.768 260.717 94.5952L261.201 96.1677C261.201 96.1677 260.724 96.0788 260.333 96.0203C259.88 95.9521 259.679 95.8853 259.103 95.6522C258.526 95.4191 258.004 94.8489 257.493 94.2131C256.982 93.5769 255.788 92.5773 255.788 92.5773C255.788 92.5773 256.157 92.6016 256.531 92.694C256.838 92.7699 257.636 93.0268 258.46 93.4512C258.642 93.545 258.744 93.6059 258.924 93.7167C259.198 93.8845 259.486 94.1347 259.761 94.4122C260.085 94.738 260.369 95 260.611 95.2916C260.347 94.8099 259.664 93.0757 258.327 91.6443C258.196 91.5041 259.251 92.1475 259.53 92.4397Z",
    fill: "#73C41D"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dddd_461_8215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.634,
    y: 82.2651,
    width: 28.8784,
    height: 28.8781,
    rx: 3.54036,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.4636,
    height: 23.4636,
    transform: "translate(215.367 85.0161)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.145 94.4157V92.7982C230.361 92.6983 230.545 92.5397 230.673 92.341C230.802 92.1422 230.871 91.9115 230.872 91.6755V91.6384C230.872 90.9505 230.307 90.3928 229.611 90.3928H229.573C229.239 90.3928 228.918 90.524 228.682 90.7576C228.445 90.9912 228.312 91.308 228.312 91.6384V91.6755C228.313 91.9115 228.382 92.1422 228.511 92.341C228.64 92.5397 228.823 92.6983 229.039 92.7982V94.4157C228.417 94.5098 227.832 94.7645 227.342 95.1541L222.85 91.6989C222.882 91.5847 222.899 91.4673 222.901 91.3494C222.902 91.0719 222.819 90.8003 222.663 90.5692C222.507 90.3381 222.286 90.1578 222.026 90.0512C221.767 89.9445 221.481 89.9162 221.206 89.9699C220.93 90.0235 220.676 90.1568 220.477 90.3528C220.278 90.5487 220.143 90.7986 220.087 91.0708C220.032 91.343 220.06 91.6252 220.167 91.8818C220.274 92.1384 220.456 92.3579 220.689 92.5124C220.923 92.667 221.197 92.7497 221.478 92.75C221.724 92.7489 221.966 92.6841 222.178 92.562L226.601 95.9612C226.203 96.554 225.996 97.2513 226.006 97.9622C226.016 98.6731 226.242 99.3646 226.655 99.9465L225.31 101.276C225.202 101.241 225.088 101.223 224.974 101.221C224.743 101.222 224.518 101.289 224.326 101.416C224.134 101.543 223.985 101.723 223.897 101.933C223.809 102.144 223.786 102.376 223.831 102.599C223.876 102.822 223.987 103.028 224.15 103.189C224.313 103.35 224.521 103.46 224.747 103.504C224.973 103.549 225.208 103.526 225.421 103.439C225.634 103.352 225.816 103.204 225.945 103.015C226.073 102.825 226.142 102.603 226.142 102.375C226.14 102.262 226.122 102.15 226.087 102.043L227.418 100.728C227.852 101.058 228.356 101.285 228.893 101.393C229.43 101.501 229.984 101.485 230.514 101.349C231.044 101.212 231.535 100.957 231.949 100.604C232.364 100.251 232.692 99.8083 232.907 99.3108C233.122 98.8133 233.218 98.2738 233.19 97.7336C233.161 97.1935 233.007 96.667 232.741 96.1945C232.474 95.722 232.102 95.316 231.652 95.0077C231.202 94.6994 230.686 94.4969 230.145 94.4157ZM229.593 99.7355C229.347 99.7422 229.103 99.7002 228.873 99.6118C228.644 99.5235 228.435 99.3907 228.259 99.2212C228.083 99.0518 227.943 98.8491 227.847 98.6253C227.751 98.4014 227.702 98.1609 227.702 97.9179C227.702 97.6749 227.751 97.4343 227.847 97.2105C227.943 96.9866 228.083 96.784 228.259 96.6145C228.435 96.4451 228.644 96.3122 228.873 96.2239C229.103 96.1356 229.347 96.0935 229.593 96.1002C230.07 96.1167 230.522 96.3152 230.853 96.654C231.184 96.9928 231.37 97.4454 231.37 97.9165C231.37 98.3876 231.185 98.8404 230.854 99.1795C230.523 99.5187 230.072 99.7177 229.595 99.7346",
    fill: "#FF7A59"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dddd_461_8215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.367,
    y: 56.9976,
    width: 32.4878,
    height: 32.4882,
    rx: 4.61914,
    transform: "rotate(90 261.367 56.9976)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.8209,
    height: 26.8209,
    transform: "translate(231.68 59.7856)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.171 69.7035C248.171 70.542 247.816 71.2832 247.236 71.8632C246.591 72.5079 245.656 72.6698 245.656 73.2174C245.656 73.9587 246.849 73.7332 247.994 74.8778C248.751 75.6355 249.218 76.6347 249.218 77.7952C249.218 80.0838 247.381 81.9055 245.076 81.9055C242.771 81.9049 240.934 80.0856 240.934 77.7958C240.934 76.6353 241.401 75.6362 242.159 74.8784C243.303 73.7344 244.496 73.9599 244.496 73.2186C244.496 72.6705 243.561 72.5091 242.916 71.8644C242.335 71.2838 241.981 70.5426 241.981 69.6724C241.981 67.9961 243.351 66.6419 245.027 66.6419C245.35 66.6419 245.64 66.6908 245.882 66.6908C246.317 66.6908 246.543 66.497 246.543 66.1909C246.543 66.0137 246.462 65.7875 246.462 65.5462C246.462 64.998 246.93 64.5464 247.494 64.5464C248.058 64.5464 248.509 65.0139 248.509 65.5779C248.509 66.1744 248.042 66.4488 247.688 66.5777C247.397 66.6743 247.171 66.8032 247.171 67.0935C247.171 67.6398 248.171 68.1721 248.171 69.7035ZM247.848 77.7964C247.848 76.2014 246.672 74.9114 245.076 74.9114C243.48 74.9114 242.304 76.2008 242.304 77.7964C242.304 79.3761 243.48 80.6821 245.076 80.6821C246.671 80.6821 247.848 79.3743 247.848 77.7964ZM246.898 69.6711C246.898 68.6561 246.076 67.8176 245.077 67.8176C244.077 67.8176 243.256 68.6561 243.256 69.6711C243.256 70.6868 244.077 71.5252 245.077 71.5252C246.076 71.5252 246.898 70.6868 246.898 69.6711Z",
    fill: "#008561"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 38.4102,
    width: 100,
    height: 90.1786,
    rx: 45.0893,
    fill: "url(#paint7_radial_461_8215)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dddd_461_8215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.9644,
    y: 62.5166,
    width: 66.0714,
    height: 66.0714,
    rx: 8.80952,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4345 74.7693C55.763 75.3207 55.6273 76.2614 56.0554 77.0175C57.1435 78.9395 58.3866 80.7726 59.6922 82.5527C61.9676 85.6549 66.6835 90.8088 71.0069 93.7081C74.671 91.4604 78.0386 90.4771 81.7387 89.4565C76.1905 86.2725 71.3962 81.9016 67.6128 76.7434C66.6023 75.3657 65.6432 73.9412 64.786 72.4624C64.3597 71.727 63.5361 71.3142 62.716 71.5378C61.8528 71.7731 60.6643 72.1728 59.3895 72.8272C58.1308 73.4733 57.1255 74.2018 56.4345 74.7693Z",
    fill: "url(#paint8_linear_461_8215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5325 92.0207C79.2696 93.0431 75.2312 94.5912 71.5888 96.8967C66.4216 100.167 62.3723 104.848 59.6921 108.502C58.3283 110.362 57.2641 112.032 56.5358 113.245C56.4009 113.47 56.2268 113.773 56.0542 114.077C55.6344 114.818 55.7276 115.741 56.357 116.314C57.043 116.939 58.0515 117.741 59.276 118.366C60.5358 119.009 61.826 119.38 62.7535 119.586C63.5584 119.765 64.3479 119.351 64.7605 118.637C65.6243 117.142 66.5922 115.703 67.6127 114.312C69.9631 111.107 73.1574 107.529 76.8422 105.196C80.4996 102.882 84.9021 101.653 88.5851 101.028C90.0806 100.775 91.5943 100.574 93.1108 100.504C94.0499 100.461 94.8465 99.7962 94.9835 98.866C95.1203 97.9375 95.2565 96.7148 95.2565 95.5276C95.2565 94.3676 95.1264 93.1738 94.9929 92.2536C94.8536 91.2932 94.0146 90.6171 93.0442 90.6182C89.8276 90.6216 86.6484 91.2733 83.5325 92.0207Z",
    fill: "#080808"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_461_8215",
    x: 220.315,
    y: 61.068,
    width: 114.592,
    height: 114.592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.62521,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26795
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.7058
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.81261,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.81261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.886275 0 0 0 0 0.917647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_461_8215",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.44658
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.35726
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_461_8215",
    result: "effect3_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.331
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_461_8215",
    result: "effect4_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_461_8215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddd_461_8215",
    x: 187.826,
    y: 61.068,
    width: 114.592,
    height: 114.592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.62521,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26795
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.7058
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.81261,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.81261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.886275 0 0 0 0 0.917647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_461_8215",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.44658
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.35726
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_461_8215",
    result: "effect3_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.331
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_461_8215",
    result: "effect4_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_461_8215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dddd_461_8215",
    x: 155.338,
    y: 61.068,
    width: 114.592,
    height: 114.592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.62521,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26795
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.7058
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.81261,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.81261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.886275 0 0 0 0 0.917647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_461_8215",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.44658
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.35726
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_461_8215",
    result: "effect3_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.331
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_461_8215",
    result: "effect4_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_461_8215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_461_8215",
    transform: "scale(0.00675676 0.00653595)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dddd_461_8215",
    x: 204.07,
    y: 37.6032,
    width: 118.202,
    height: 118.202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.62521,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26795
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.7058
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.81261,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.81261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.886275 0 0 0 0 0.917647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_461_8215",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.44658
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.35726
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_461_8215",
    result: "effect3_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.331
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_461_8215",
    result: "effect4_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_461_8215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dddd_461_8215",
    x: 167.972,
    y: 37.6032,
    width: 118.202,
    height: 118.202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.62521,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26795
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.7058
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.81261,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.81261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.886275 0 0 0 0 0.917647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_461_8215",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.44658
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.35726
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_461_8215",
    result: "effect3_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.331
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_461_8215",
    result: "effect4_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_461_8215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dddd_461_8215",
    x: 184.216,
    y: 12.3356,
    width: 121.812,
    height: 121.812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.62521,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26795
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.7058
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.81261,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.81261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.886275 0 0 0 0 0.917647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_461_8215",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.44658
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.35726
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_461_8215",
    result: "effect3_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.331
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_461_8215",
    result: "effect4_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_461_8215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dddd_461_8215",
    x: 0.964355,
    y: 21.5166,
    width: 148.072,
    height: 148.071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.886275 0 0 0 0 0.917647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_461_8215",
    result: "effect2_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_461_8215",
    result: "effect3_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_461_8215",
    result: "effect4_dropShadow_461_8215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_461_8215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_461_8215",
    x1: 237.321,
    y1: 136.964,
    x2: 234.093,
    y2: 142.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_461_8215",
    x1: 356.246,
    y1: 112.644,
    x2: 219.291,
    y2: 285.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABE57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_461_8215",
    x1: 216.105,
    y1: 172.478,
    x2: 154.842,
    y2: 223.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE8AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_461_8215",
    x1: 90.7629,
    y1: 53.5507,
    x2: 93.4999,
    y2: 48.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_461_8215",
    x1: -28.225,
    y1: 77.4187,
    x2: 108.73,
    y2: -95.5453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABE57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_461_8215",
    x1: 111.916,
    y1: 17.5853,
    x2: 173.179,
    y2: -33.5615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE8AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC975"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_461_8215",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(229 134.499) rotate(113.356) scale(23.9635 28.4273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_461_8215",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75 83) rotate(-59.0362) scale(46.6476 44.8614)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.639477,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_461_8215",
    x1: 96.2753,
    y1: 78.9035,
    x2: 54.7809,
    y2: 114.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080808",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_8215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.4094,
    height: 11.0556,
    fill: "white",
    transform: "translate(271.301 112.947)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_461_8215",
    width: 1168,
    height: 153,
    xlinkHref: "data:image/png;base64,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"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFeatureDiscoverySyncFrequency, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/feature-discovery-sync-frequency.8256c1f8.svg";
export { ForwardRef as ReactComponent };